import React from 'react'
import { motion } from 'framer-motion'
import { FiTarget, FiAward, FiTrendingUp } from 'react-icons/fi'
import './About.css'

const About = () => {
  const stats = [
    { icon: FiTarget, label: 'Projects Completed', value: '7+' },
    { icon: FiAward, label: 'Years Experience', value: '10+' },
    { icon: FiTrendingUp, label: 'Avg Satisfaction', value: '98%' },
  ]

  return (
    <section id="about" className="about section light">
      <div className="container">
        <h2 className="section-title">About Me</h2>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {/* <p>
              I'm a passionate data analyst with a keen eye for transforming raw data into meaningful insights.
              My expertise spans data analysis, business intelligence, and strategic decision-making.
            </p>
            <p>
              I excel at identifying patterns, uncovering trends, and presenting data-driven recommendations that
              drive business growth. Whether it's SQL queries, Python analysis, or interactive dashboards, I bring
              precision and clarity to every project.
            </p>
            <p>
              Outside of work, I'm continuously learning new tools and technologies to stay ahead in the rapidly
              evolving field of data analytics.
            </p> */}
            <p>
              Business and Data Analyst with 10+ years of experience supporting
              operational workflows, analyzing complex datasets, and improving
              business processes across healthcare and enterprise environments —
              including over a decade at SunRiver Health and PepsiCo.
            </p>
            <p>
              I specialize in root cause analysis, SAP systems support, data
              validation, and translating complex operational data into clear,
              actionable insights for cross-functional stakeholders. My toolset
              includes SAP S/4HANA, Excel (advanced), SQL, and eClinicalWorks.
            </p>
            <p>
              Currently pursuing my ECBA certification in Business Analysis, and
              recently certified in SQL for Data Science and SAP S/4HANA
              Sourcing & Procurement — always building on a strong foundation in
              compliance, process improvement, and data-driven decision-making.
            </p>
          </motion.div>

          <div className="about-stats">
            {stats.map((stat, index) => {
              const Icon = stat.icon
              return (
                <motion.div
                  key={index}
                  className="stat-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -10 }}
                >
                  <div className="stat-icon">
                    <Icon />
                  </div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </motion.div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
